<template>
    <card class="mb-4">
        <card-body class="d-flex">
            <input class="form-control" autofocus="autofocus" type="text"
                   :placeholder="placeholder" v-model="search" @input="$emit('input', search)"
                   @keyup.enter="$emit('search', search)"/>
        </card-body>
    </card>
</template>

<script>
    export default {
        props: {
            value: {required: true},
            placeholder: {default: 'Search...'},
        },

        data: () => ({
            search: this.value,
        }),

        watch: {
            value() {
                this.search = this.value;
            },
        },
    };
</script>
